import { render, staticRenderFns } from "./add.vue?vue&type=template&id=3839e72d&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=3839e72d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3839e72d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3839e72d')) {
      api.createRecord('3839e72d', component.options)
    } else {
      api.reload('3839e72d', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=3839e72d&scoped=true", function () {
      api.rerender('3839e72d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/convalescenceSystem/convalescenceInfo/add.vue"
export default component.exports